<template>
  <div v-html="bodyHtml" />
</template>

<script>

import RichTextResolver from 'storyblok-js-client/dist/rich-text-resolver.es'

export default {
  name      : 'AppRichtext',
  components: { },
  props     : { content: { type: Object, default: null } },
  computed  : {
    bodyHtml () {
      const resolver = new RichTextResolver()
      return resolver.render(this.content)
    },
  },

}
</script>
